import {
  AuthorizerConsultPlanTermsResponseDTO,
  AuthorizerRequestDTO
} from "@repo/core/services/entities/Authorizer";
import { AxiosInstance, AxiosResponse } from "axios";

const resourcePrefix = "/Autorizador";
export class AuthorizerResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async consultPlanTerms({
    strProduto,
    lngCartao,
    strCodigoEstabelecimento,
    strTipoOperacao,
    dblValorOperacao,
    strSemJuros = "N"
  }: AuthorizerRequestDTO): Promise<
    AxiosResponse<AuthorizerConsultPlanTermsResponseDTO>
  > {
    return this.apiProvider.get(
      `${resourcePrefix}/SimularPlanosPrazos?strProduto=${strProduto}&lngCartao=${lngCartao}&strCodigoEstabelecimento=${strCodigoEstabelecimento}&strTipoOperacao=${strTipoOperacao}&dblValorOperacao=${dblValorOperacao}&strSemJuros=${strSemJuros}`
    );
  }
}
